import { useState, useEffect, useRef } from "react";

export const useTabs = (indexLength) => {
    const [index, setIndex] = useState(0)
    const [focusIndex, setFocusIndex] = useState(false)
    const didMount = useRef(false)
    const maxIndex = indexLength - 1

    useEffect(() => {
        if(!didMount.current) {
            didMount.current = true;
            return
        }

        setFocusIndex(index)
    }, [index])

    const onKeydown = (event) => {
        let flag = false

        switch (event.key) {
            case 'ArrowLeft':
                setIndex(Math.max(0, index - 1))
                flag = true
                break

            case 'ArrowRight':
                setIndex(Math.min(maxIndex, index + 1))
                flag = true
                break

            case 'Home':
                setIndex(0)
                flag = true
                break

            case 'End':
                setIndex(maxIndex)
                flag = true
                break

            default:
                break
        }

        if(flag) {
            event.stopPropagation()
            event.preventDefault()
        }
    }

    const handleClick = (i) => {
        if(index !== i) {
            setIndex(i)
        }
    }

    return [index, focusIndex, onKeydown, handleClick]
}